import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const formularioAssociadoItemProcessoSlice = createSlice({
  name: 'formularioAssociadoItemProcesso',
  initialState,
  reducers: {
    carregarFormularioAssociadoItemProcesso: (state, action) => {
      const { idProcessoItem, formulario } = action.payload;
      state[idProcessoItem] = formulario;
    },
    limparFormularioAssociadoItemProcesso: (state, action) => {
      delete state[action.payload];
    },
  },
});

export const {
  carregarFormularioAssociadoItemProcesso,
  limparFormularioAssociadoItemProcesso,
} = formularioAssociadoItemProcessoSlice.actions;

export default formularioAssociadoItemProcessoSlice.reducer;
